/**
 * DataAcquisitionService - Refactorisé pour utiliser le client API centralisé
 */
import apiClient from '../../../services/api';

export default class DataAcquisitionService {
    getExchangeValues = () => {
        return apiClient.post("/getExchangeValues");
    }

    GetSectorsByExchnage = (body) => {
        return apiClient.post("/getSectorByExchange", body);
    }

    getIndustryByExchangeAndSector = (body) => {
        return apiClient.post("/getIndustryByExchangeSector", body);
    }

    getCompaniesByIndustryExchangeAndSector = (body) => {
        return apiClient.post("/getCompaniesByExchangeSectorIndustry", body);
    }

    getDataAcquisitionTypes = () => {
        return apiClient.get("/dataAcquisitionApiTypes");
    }

    getDataAcquisitionYearLimits = () => {
        return apiClient.get("/dataAcquisitionYearLimits");
    }

    dataAcquisitionApi = (body) => {
        return apiClient.post("/dataAcquisition/Api", body);
    }

    dataAcquisitionFileUpload = (body) => {
        return apiClient.post("/dataAcquisition/fileUpload", body);
    }
}
